import gql from 'graphql-tag';
import fragments from '../fragments';

export default {
    updateCampaignMutation: gql`
        mutation UpdateCampaign($campaignID: String!, $status: String, $name: String, $termsText: String, $privacyText: String, $promptText: String,
            $successText: String, $successLink: String, $successLinkLabel: String, $successShareEnabled: Boolean, $enforcesTermsAndConditionsConsent: Boolean,
            $enforcesPrivacyPolicyConsent: Boolean, $boostWords: String, $hideBeamsBranding: Boolean, $image: ImageInput,
            $backgroundImage: ImageInput, $color: String, $maximumRecordingDuration: Int,
            $termsAndConditionsConsentText: String, $privacyPolicyConsentText: String, $NPSQuestion: String, $promptSublineText: String, $recordButtonLabel: String,
            $CSATQuestion: String, $interfaceLanguage: String, $enabledWidgets: [String], $backgroundColor: String
            $collectNames: CollectUserData, $collectEmails: CollectUserData, $collectImages: CollectUserData, $videoURLs: [String],
            $conversationalSurvey: Boolean, $newRecorder: Boolean, $agentWelcomeMessage: String, $textFieldDefault: Boolean, $removeBackgroundImage: Boolean,
            $autoDetectsSpeechLanguage: Boolean) {
            updateCampaign(
                campaignID: $campaignID
                campaign: {
                    status: $status
                    name: $name
                    termsText: $termsText
                    privacyText: $privacyText
                    promptText: $promptText
                    successText: $successText
                    successLink: $successLink
                    successLinkLabel: $successLinkLabel
                    successShareEnabled: $successShareEnabled
                    enforcesTermsAndConditionsConsent: $enforcesTermsAndConditionsConsent
                    enforcesPrivacyPolicyConsent: $enforcesPrivacyPolicyConsent
                    boostWords: $boostWords
                    hideBeamsBranding: $hideBeamsBranding
                    image: $image
                    backgroundImage: $backgroundImage
                    color: $color
                    backgroundColor: $backgroundColor
                    maximumRecordingDuration: $maximumRecordingDuration
                    termsAndConditionsConsentText: $termsAndConditionsConsentText
                    privacyPolicyConsentText: $privacyPolicyConsentText
                    NPSQuestion: $NPSQuestion
                    promptSublineText: $promptSublineText
                    recordButtonLabel: $recordButtonLabel
                    CSATQuestion: $CSATQuestion
                    interfaceLanguage: $interfaceLanguage
                    enabledWidgets: $enabledWidgets
                    collectNames: $collectNames
                    collectEmails: $collectEmails
                    collectImages: $collectImages
                    videoURLs: $videoURLs
                    conversationalSurvey: $conversationalSurvey
                    newRecorder: $newRecorder
                    agentWelcomeMessage: $agentWelcomeMessage
                    textFieldDefault: $textFieldDefault
                    removeBackgroundImage: $removeBackgroundImage
                    autoDetectsSpeechLanguage: $autoDetectsSpeechLanguage
                }
            ) {
                ...CampaignFragment
            }
        }

        ${fragments.campaign}
        ${fragments.image}
        ${fragments.tag}
    `,
};
